//TODO: remove this once V1->V2 migration is done

import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Text, Flex, Icon, Stack, Box as Wrapper } from '@tonic-ui/react';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../context/AuthContext';
import { gotoSignIn } from '../../utils/helpers';

const MigrationConfirmatiion = () => {
  const { eventDistributor } = useContext(AuthContext);

  const { t } = useTranslation();
  const history = useHistory();
  const {
    location: { state = {} },
  } = history;
  const { successStatus = '' } = state;

  useEffect(() => {
    if (successStatus === '') {
      gotoSignIn(eventDistributor);
    }
    eventDistributor.dispatch({ type: 'HIDE_UNAUTH_STATE_LOADING_INDICATOR', loading: false });
  }, [successStatus]);

  return (
    <Wrapper maxWidth={400} margin="128px auto">
      <Stack spacing="4x">
        <Flex size="md" lineHeight="lg">
          <Icon icon="check" color="green:50" />
          <Text size="md" lineHeight="lg" marginLeft={12}>
            {successStatus === 'sent'
              ? t('migrateAccount.successMessage')
              : t('migrateAccount.resend.successMessage')}
          </Text>
        </Flex>
        <Text size="md" lineHeight="lg">
          {t('migrateAccount.autoLogoutInfo')}
        </Text>
      </Stack>
    </Wrapper>
  );
};

export default MigrationConfirmatiion;
